module.exports = __webpack_public_path__ + "img/202346113538.ffc17923.jpg";